const positiveNumberDirective = {
  bind(el, binding, vnode) {
    // 初始获取最大值
    let maxValue = binding.value && binding.value.maxValue !== undefined ? binding.value.maxValue : 99999999999999; // 允许输入的最大值
    function inputHandler(event) {
      let newValue = event.target.value;
      const allowZero = binding.value && binding.value.allowZero !== undefined ? binding.value.allowZero : true; // 是否允许取0
      const decimalPlaces = binding.value && binding.value.decimalPlaces !== undefined ? binding.value.decimalPlaces : 0; // 允许填写的小数位数
      // 保存原始光标位置
      const originalCursorPosition = event.target.selectionStart;
      // 移除所有非数字和小数点的字符
      newValue = newValue.replace(/[^\d.]/g, '');
      // 处理多个小数点的情况
      let indexOfDot = newValue.indexOf('.');
      if (indexOfDot !== -1 && indexOfDot !== newValue.lastIndexOf('.')) {
        newValue = newValue.slice(0, indexOfDot) + newValue.slice(indexOfDot + 1);
      }
      // 处理以小数点开头的情况
      if (newValue.startsWith('.')) {
        newValue = '0' + newValue;
      }
      // 处理小数点后超过指定位数的情况
      if (newValue.split('.')[1] && newValue.split('.')[1].length > decimalPlaces) {
        newValue = `${newValue.split('.')[0]}.${newValue.split('.')[1].substring(0, decimalPlaces)}`;
      }
      // 处理前导零
      if (newValue.length > 1 && newValue.startsWith('0') && !newValue.startsWith('0.')) {
        newValue = newValue.replace(/^0+/, '');
      }
      // 不允许输入小数点但允许输入整数
      if (decimalPlaces === 0 && newValue.includes('.')) {
        newValue = newValue.split('.')[0];
      }
      // 最后再检查数值是否小于0，若小于0则置为空字符串，或者不允许为0时置为空字符串
      if (Number(newValue) < 0 || (!allowZero && Number(newValue) === 0)) {
        newValue = '';
      }
      // 检查是否超过最大允许数值
      if (Number(newValue) > maxValue) {
        newValue = maxValue.toString();
      }
      // 更新DOM中的值
      if (newValue !== event.target.value) {
        const diff = event.target.value.length - newValue.length;
        event.target.value = newValue;
        vnode.componentInstance.$emit('input', newValue);
        // 恢复光标位置
        event.target.setSelectionRange(originalCursorPosition - diff, originalCursorPosition - diff);
      }
    }
    el.addEventListener('input', inputHandler);
    // 监听 totalNum 的变化，并更新 maxValue
    vnode.context.$watch(() => vnode.context.totalNum, (newVal) => {
      maxValue = newVal;
    });
    // 在unbind钩子中移除事件监听，防止内存泄漏
    el.handler = inputHandler;
  },
  unbind(el) {
    el.removeEventListener('input', el.handler);
  },
};

export default positiveNumberDirective;



// WEBPACK FOOTER //
// ./src/utils/positiveNumberDirective.js